import React, { useEffect } from 'react';
import {
    Box,
    Button,
    TextField,

} from '@mui/material';
import {
    createState,
    Downgraded,
    useState,
} from '@hookstate/core';
import LoadingButton from '@mui/lab/LoadingButton';
import * as forge from 'node-forge';
import { withRouter, useHistory } from 'react-router-dom';
import Logo from '../../assets/images/logo.png';
import APIURLConstants from '../../config/config';
import APIHelper from '../../utility/ApiHelper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
// import RouteConstants from '../../constants/routeConstants';

const userState = createState({
    password: '',
    cpassword: "",
});

const helperRoot = {
    margin: 0,
};

const ResetPassword = (props) => {
    const state = useState(userState);
    const loading = useState(false);
    const history = useHistory()
    const path = window.location.search;
    let params = new URLSearchParams(path);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [passMatchErr, setPassMatchErr] = React.useState(false)
    const validateCpassword = () => {
        const password = state.password.get().trim();
        const cpassword = state.cpassword.get().trim();

        if (password !== cpassword) {
            setPassMatchErr(true)
            return false;

        } else {
            setPassMatchErr(false)
            return true;
        }

    };


    useEffect(() => {
        props.setLogin(false);
    }, [])
    const handleCancel = () => {
        history.push({ pathname: '/' })
        props.setLogin(true);
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        if (state.password.get() != '') {
            let val = validateCpassword();
            if (!val) {
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Password and Confirm Pasword should be same',
                });
            } else {
                loading.set(true);
                let req = { ...state.attach(Downgraded).get() };
                // eslint-disable-next-line no-undef
                const publicKey = process.env.REACT_APP_PUBLIC_KEY;

                var rsa = forge.pki.publicKeyFromPem(publicKey);
                let encryptedPassword = window.btoa(rsa.encrypt(req.password));

                req = {
                    password: encryptedPassword,
                    resetToken: params.get('code')
                };

                APIHelper.post(APIURLConstants.POST_RESET_PASSWORD, req)
                    .then((res) => {
                        if (res.data.status === 200) {
                            // Helper.setStorage('chk', 'jr');

                            const response = (res.data);
                            console.log(response)
                            if (response.ok) {

                                snackBarProps.openSnack = true;
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: true,
                                    variant: 'success',
                                    message: 'Password changed successfully',
                                });
                                setTimeout(() => {
                                    history.push({ pathname: '/' })
                                    props.setLogin(true);
                                }, 2000);
                                state.email.set('')
                            } else {
                                snackBarProps.openSnack = true;
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: true,
                                    variant: 'error',
                                    message: response.message,
                                });
                            }
                        } else {
                            snackBarProps.openSnack = true;
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: true,
                                variant: 'error',
                                message: res.data.message,
                            });
                        }
                        loading.set(false);
                    })
                    .catch((error) => {
                        let message = 'Something went wrong!';
                        console.log(error)
                        snackBarProps.openSnack = true;
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: message,
                        });
                        loading.set(false);
                    });
            }
        } else {
            loading.set(false);
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Password should not be empty!',
            });

        }

    };

    return (

        <>
            <Box
                sx={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}>
                <Box className="confirmBox">
                    <Box className="loginHeader">
                        <Box
                            component="img"
                            alt="logo."
                            src={Logo}
                            sx={{ height: 42 }}
                        />
                    </Box>
                    <Box className="loginContentBox">
                        <Box
                            autoComplete="off"
                        >
                            <Box className="textContent">
                                <TextField
                                    required
                                    size="small"
                                    label="New Password"
                                    type={'password'}
                                    autoComplete="off"
                                    value={state.password.get()}
                                    onChange={(event) => {
                                        let str = event.target.value;
                                        str = str.replace(/^\s+/g, '');
                                        state.password.set(str);
                                    }}

                                    inputProps={{ maxLength: 100 }}
                                    sx={{ width: '100%' }}
                                    FormHelperTextProps={{
                                        classes: {
                                            root: helperRoot,
                                        },
                                    }}
                                />
                            </Box>
                            <Box className="textContent">
                                <TextField
                                    required
                                    type="password"
                                    size="small"
                                    label="Confirm New Password"
                                    autoComplete="off"
                                    value={state.cpassword.get()}
                                    onChange={(event) => {
                                        state.cpassword.set(
                                            event.target.value
                                        );
                                    }}
                                    onBlur={() => validateCpassword()}
                                    inputProps={{ maxLength: 30 }}
                                    sx={{ width: '100%' }}
                                    error={passMatchErr}
                                />
                            </Box>


                        </Box>
                        <Box className="textContent" sx={{ pt: 3 }}>
                            <LoadingButton
                                loading={loading.get()}
                                color='primary'
                                variant="contained"
                                loadingPosition='end'
                                onClick={handleSubmit}
                                sx={{ width: '100%' }}

                            >
                                Change Password
                            </LoadingButton>
                        </Box>

                        <Box className="textContent">
                            <Button
                                onClick={handleCancel}
                                variant="contained"
                                color="secondary"
                                sx={{ width: '100%' }}
                            >
                                Cancel
                            </Button>
                        </Box>

                    </Box>
                </Box>
            </Box>


            {
                snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )
            }
        </>
    );
};
export default withRouter(ResetPassword);
